import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchCategoryMapApiClient extends AdvancedApiClient {

    static entityType = "FarfetchCategoryMap"

    constructor(token, categoryId, id) {
        super();

        this.setEntityType(FarfetchCategoryMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/category/{cid}/farfetch-map/{id}")
                .setRouteParam("cid", categoryId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/category/{cid}/farfetch-map")
                .setRouteParam("cid", categoryId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}